module.exports = __webpack_public_path__ + "img/Expo_Topic6.e47db0bf.png";